<template>
  <div
    v-if="((isMobile && showProfile) || (!isMobile))"
    class="human-profile-container">
    <b-modal
      ignore-enforce-focus-selector=".header"
      modal-class="padding-top_modal-list"
      hide-header
      hide-footer
      dialog-class="app__add-friend-modal"
      body-class="app__modal_body app__add-friend-modal_body"
      content-class="modal_content"
      id="change-currency">
      <change-single-currency-form/>
    </b-modal>
    <section
      v-if="payoutsStatus === 'loading'"
      class="human-profile-plug">
      <app-loader
        class="human-card-loader"
      />
    </section>
    <section
      v-else-if="payoutsStatus !== 'loading' && arePayoutsEmpty"
      class="empty-human-profile">
      <empty-human-profile />
    </section>
    <section
      v-else-if="payoutsStatus !== 'loading'"
      class="human-profile">
      <button
        v-if="isMobile"
        @click="toggleShowProfile"
        class="operation-options-button">
        <font-awesome-icon icon="chevron-left" class="chevron-icon-left"/>
      </button>
      <human-card
        v-if="payoutsStatus === 'success'"
        :active-user="activeUser"
        class="human-profile__human-card"
      />
      <div v-if="payoutsStatus !== 'loading'" class="button-group">
        <button-app
          class="button-group__button"
          color-scheme="gray"
          @clicked="$bvModal.show('change-currency')"
        >
          {{ $t('CP.changeCurrency') }}
        </button-app>
        <button-app
          v-if="activeUser.uid !== user.user"
          @clicked="sendAllPayouts"
          :disabled="activeUser && !(activeUser.amount < 0)"
          class="button-group__button"
          color-scheme="gray"
        >
          {{ $t('humanProfile.makePayments') }}
        </button-app>
      </div>
      <div class="events">
        <div
          v-if="payoutsStatus === 'success' && eventsStatus === 'success'"
          class="events__title">
          {{ $t('CP.events') }}:
        </div>
        <div
          v-if="payoutsStatus === 'success' && eventsStatus === 'success'"
          class="list-jumper"
        >
          <event-list
            class="event-list"
            :currency="eventsCurrency"
            margin-top="8px"
            :current-event="event"
            :on-select-event="loadEvent"
            :events="filterContactEvents"
            :events-status="payoutsStatus"
            :onDeleteEvent="onDeleteEvent"
            :show-unread-messages="true"
            no-events-phrase="eventList.noEventsFound"
          />
        </div>
        <page-error v-else-if="eventsStatus === 'error'" :showLang="false">
          <template #message>
            {{ $t('CP.errorOccurred') }}
          </template>
        </page-error>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  CLEAR_EVENT_DATA,
  DELETE_EVENT_REQUEST,
  FETCH_EVENTS_REQUEST,
  SEND_ALL_PAYOUTS_REQUEST,
} from '@/store/events/types';
import PageError from '../PageError/PageError';
import ButtonApp from '../../components/Button/ButtonApp';
import EventList from '../../components/EventList/EventList';
import HumanCard from '../../components/HumanCard/HumanCard';
import ChangeSingleCurrencyForm from '../../forms/ChangeSingleCurrencyForm/ChangeSingleCurrencyForm';
import AppLoader from '../../components/AppLoader/AppLoader';
import EmptyHumanProfile from '../../components/EmptyHumanProfile/EmptyHumanProfile';

export default {
  name: 'HumanProfile',
  components: {
    EmptyHumanProfile,
    AppLoader,
    ChangeSingleCurrencyForm,
    HumanCard,
    EventList,
    ButtonApp,
    PageError,
  },
  props: {
    showProfile: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    arePayoutsEmpty: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      status: '',
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      events: (state) => state.events.events,
      eventsStatus: (state) => state.events.eventsStatus,
      payoutsStatus: (state) => state.events.userPayoutsStatus,
      payoutsCurrency: (state) => state.events.userPayoutsCurrency,
      eventsCurrency: (state) => state.events.eventsCurrency,
      event: (state) => state.events.event,
      activeUser: (state) => state.events.payoutsActiveUser || {},
    }),
    getContactEvents() {
      return this.activeUser.events;
    },
    filterContactEvents() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.status = 'loading';
      if (this.events) {
        const events = this.events
          .filter((event) => event.contacts
            .findIndex((eventContact) => this.activeUser.uid === eventContact.uid) !== -1);
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.status = this.eventsStatus;
        return events;
      }
      return [];
    },
  },
  methods: {
    async sendAllPayouts() {
      await this.$store.dispatch(SEND_ALL_PAYOUTS_REQUEST, {
        id: this.activeUser.uid,
        currency: this.userPayoutsCurrency,
      });
      await this.$store.dispatch(FETCH_EVENTS_REQUEST);
    },
    loadEvent(id) {
      this.$store.commit(CLEAR_EVENT_DATA);
      this.$router.push(`/events/${id}`);
    },
    toggleShowProfile() {
      this.$emit('toggleShowProfile');
    },
    onDeleteEvent(event) {
      this.$bvModal.msgBoxConfirm(this.$t('CP.confirmDeleteEvent'), {
        title: event.event_name,
        buttonSize: 'md',
        okVariant: 'danger',
        okTitle: this.$t('CP.yes'),
        cancelTitle: this.$t('CP.cancel'),
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      })
        .then((isConfirmed) => {
          if (isConfirmed) this.$store.dispatch(DELETE_EVENT_REQUEST, event.id);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.human-profile-container {
  height: 100%;
  overflow-y: auto;
  background-color: #FFFFFF;
  flex: 0 1 100%;
  padding: 39px 5%;
  display: flex;
  justify-content: center;
  align-content: flex-start;
}
.human-profile {
  min-height: calc(var(--height-full) - 80px);
  position: relative;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: flex-start;
  max-width: 700px;
  min-width: 500px;
}

.human-profile-plug {
  height: 80%;
  display: flex;
  align-items: center;
}

.empty-human-profile {
  display: flex;
  justify-content: center;
  align-items: center;
}

.human-card-loader {
  margin: 5vh auto 8vh;
}

.human-profile__human-card {
  min-height: 100px;
}

.button-group {
  /*flex: 0 1 508px;*/
  min-height: 58px;
  display: flex;
}

.button-group__button {
  font-size: 13px;
  margin: 20px 8px 0 0;
}

.events {
  flex: 0 1 508px;
  padding: 0;
}

.events__title {
  text-align: left;
  opacity: 0.6;
  height: 30px;
  font-size: 16px;
  margin: 24px 0 0;
}

.list-jumper {
  position: relative;
}

.event-list {
  padding-bottom: 20px;
}
.error-message {
  color: var(--error-red);
  height: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: $breakpoint-sm) {
  .human-profile-container {
    padding: 60px 3%;
  }
  .human-profile {
    min-width: 350px;
  }
  .operation-options-button {
    position: absolute;
    top: 30px;
    right: 30px;
    background-color: #FFFFFF;
    color: var(--btn-primary);
    border: none;
    outline: none;
    width: 23px;
    height: 23px;
    box-sizing: border-box;
    padding: 0;
    border-radius: 50%;
    z-index: 1;
  }
  .chevron-icon-left {
    color: var(--btn-primary);
    width: 15px;
    height: 24px;
  }
}
</style>
